import React from "react";
import clsx from "clsx";

const NarrowContainer = ({ children, className }) => {
    return (
        <div
            className={clsx(
                "grid grid-cols-8 sm:grid-cols-12",
                "gap-x-4 sm:gap-x-6 lg:gap-x-8",
                "px-4 sm:px-0",
                "mx-auto",
                "py-12 lg:py-16",
                "max-w-1400px",
                className
            )}
        >
            <div className="
                col-span-8 col-start-1 
                sm:col-span-8 sm:col-start-3 sm:col-end-11
                lg:col-span-6 lg:col-start-4 lg:col-end-10
            ">
                {children}
            </div>
        </div>
    );
};

export default NarrowContainer;